import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { PortfolioGeneralUIState } from './portfolioGeneralSlice';

// Base selector
export const getPortfolioGeneralState = (state: RootState): PortfolioGeneralUIState => {
    return (
        state.portfolio?.portfolioGeneral || {
            selectedFilters: [],
        }
    );
};

// Derived selectors
export const getCurrentPortfolioFilters = createSelector(
    [getPortfolioGeneralState],
    portfolioGeneralState => portfolioGeneralState.selectedFilters
);
